module.exports = __webpack_public_path__ + "img/login-shapes.8ccca30e.png";